import React, { Component } from 'react';

class Loading extends Component {
  render(){
    return (
      <div className="loader">
      	<div className="spinner">
          <div className="double-bounce1"></div>
          <div className="double-bounce2"></div>
        </div>
        <span>Ladataan....</span>
      </div>
      );
  }
}

export default Loading; 


// WEBPACK FOOTER //
// ./src/Components/Loading.jsx